import { initializeApp } from "firebase/app"
import "firebase/storage";
import "firebase/auth";
import {firebaseConfig} from '../../../config';
import {initializeAnalytics} from 'firebase/analytics';

const app = initializeApp(firebaseConfig);

export const firebaseAnalytics = initializeAnalytics(app, {
  config: {
    debug_mode: process.env.REACT_APP_FIREBASE_DEBUG_MODE === "true"
  }
});

export default app;